
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/speakers",
      function () {
        return require("private-next-pages/sa/speakers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/speakers"])
      });
    }
  